// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quill {
    overflow-x: auto;
}

.ql-container.ql-snow {
    width: 100%;
    height: 500px;
    min-height: 43px;
    resize: vertical;
    overflow-x: hidden;
}

.ql-snow .ql-picker-options {
    padding: 4px 12px;
}

.ql-snow .ql-picker.ql-size .ql-picker-item {
    text-align: left;
}

.ql-snow .ql-picker.ql-size .ql-picker-item::before,
.ql-snow .ql-picker.ql-size .ql-picker-label::before {
    content: attr(data-value);
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
    font-size: 14px;
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
    font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
    font-size: 18px;
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
    font-size: 20px;
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
    font-size: 24px;
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
    font-size: 32px;
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="48px"]::before {
    font-size: 48px;
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before {
    content: 'Arial';
    font-family: "Arial", sans-serif;
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Serif"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Serif"]::before {
    content: 'Serif';
    font-family: "Serif", sans-serif;
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Sans-serif"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Sans-serif"]::before {
    content: 'Sans-serif';
    font-family: "sans-serif";
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Courier"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Courier"]::before {
    content: 'Courier';
    font-family: "Courier", sans-serif;
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Georgia"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Georgia"]::before {
    content: 'Georgia';
    font-family: "Georgia", sans-serif;
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Impact"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Impact"]::before {
    content: 'Impact';
    font-family: "Impact", sans-serif;
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Tahoma"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Tahoma"]::before {
    content: 'Tahoma';
    font-family: "Tahoma", sans-serif;
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Verdana"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Verdana"]::before {
    content: 'Verdana';
    font-family: "Verdana", sans-serif;
}

.ql-font-Arial { font-family: 'Arial', sans-serif; }
.ql-font-Serif { font-family: 'Serif', serif; }
.ql-font-Sans-serif { font-family: 'Sans-serif', sans-serif; }
.ql-font-Courier { font-family: 'Courier', monospace; }
.ql-font-Georgia { font-family: 'Georgia', serif; }
.ql-font-Impact { font-family: 'Impact', sans-serif; }
.ql-font-Tahoma { font-family: 'Tahoma', sans-serif; }
.ql-font-Verdana { font-family: 'Verdana', sans-serif; }`, "",{"version":3,"sources":["webpack://./src/styles/TextEditor.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA,iBAAiB,gCAAgC,EAAE;AACnD,iBAAiB,2BAA2B,EAAE;AAC9C,sBAAsB,qCAAqC,EAAE;AAC7D,mBAAmB,iCAAiC,EAAE;AACtD,mBAAmB,6BAA6B,EAAE;AAClD,kBAAkB,iCAAiC,EAAE;AACrD,kBAAkB,iCAAiC,EAAE;AACrD,mBAAmB,kCAAkC,EAAE","sourcesContent":[".quill {\n    overflow-x: auto;\n}\n\n.ql-container.ql-snow {\n    width: 100%;\n    height: 500px;\n    min-height: 43px;\n    resize: vertical;\n    overflow-x: hidden;\n}\n\n.ql-snow .ql-picker-options {\n    padding: 4px 12px;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item {\n    text-align: left;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item::before,\n.ql-snow .ql-picker.ql-size .ql-picker-label::before {\n    content: attr(data-value);\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"14px\"]::before {\n    font-size: 14px;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"16px\"]::before {\n    font-size: 16px;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"18px\"]::before {\n    font-size: 18px;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"20px\"]::before {\n    font-size: 20px;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"24px\"]::before {\n    font-size: 24px;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"32px\"]::before {\n    font-size: 32px;\n}\n\n.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=\"48px\"]::before {\n    font-size: 48px;\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"Arial\"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"Arial\"]::before {\n    content: 'Arial';\n    font-family: \"Arial\", sans-serif;\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"Serif\"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"Serif\"]::before {\n    content: 'Serif';\n    font-family: \"Serif\", sans-serif;\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"Sans-serif\"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"Sans-serif\"]::before {\n    content: 'Sans-serif';\n    font-family: \"sans-serif\";\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"Courier\"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"Courier\"]::before {\n    content: 'Courier';\n    font-family: \"Courier\", sans-serif;\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"Georgia\"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"Georgia\"]::before {\n    content: 'Georgia';\n    font-family: \"Georgia\", sans-serif;\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"Impact\"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"Impact\"]::before {\n    content: 'Impact';\n    font-family: \"Impact\", sans-serif;\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"Tahoma\"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"Tahoma\"]::before {\n    content: 'Tahoma';\n    font-family: \"Tahoma\", sans-serif;\n}\n\n.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"Verdana\"]::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"Verdana\"]::before {\n    content: 'Verdana';\n    font-family: \"Verdana\", sans-serif;\n}\n\n.ql-font-Arial { font-family: 'Arial', sans-serif; }\n.ql-font-Serif { font-family: 'Serif', serif; }\n.ql-font-Sans-serif { font-family: 'Sans-serif', sans-serif; }\n.ql-font-Courier { font-family: 'Courier', monospace; }\n.ql-font-Georgia { font-family: 'Georgia', serif; }\n.ql-font-Impact { font-family: 'Impact', sans-serif; }\n.ql-font-Tahoma { font-family: 'Tahoma', sans-serif; }\n.ql-font-Verdana { font-family: 'Verdana', sans-serif; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
